import React from 'react';

import type { ListType } from '~/components-ds/ReviewList';
import ReviewList from '~/components-ds/ReviewList';
import { QUOTE_ROUTE } from '~/constants/routes';
import { useAppContent, useQuote } from '~/hooks';
import { CurrencyFormat, currencyFormatter } from '~/utils/currencyFormatter';

interface ReviewExcessProps {}

const ReviewExcess: React.FC<ReviewExcessProps> = () => {
  const { getTextContent } = useAppContent({ basePath: 'dsme.review.fields.excess' });

  const { levelOfExcess } = useQuote();
  const excessReviewList = [
    {
      label: getTextContent('level'),
      data: currencyFormatter(levelOfExcess, CurrencyFormat.Comma),
    },
  ];
  return (
    <ReviewList
      list={
        excessReviewList.reduce(
          (prev, curr, idx) => ({
            ...prev,
            [String(idx)]: {
              id: idx,
              name: curr.label,
              label: curr.label,
              value: curr.data,
            },
          }),
          {}
        ) as ListType
      }
      title={getTextContent('title')}
      editRoute={QUOTE_ROUTE}
    />
  );
};

export default ReviewExcess;
